<div
  class="legal-page"
  [class.client-source]="isClientSource()"
  [class.veterinarian]="isVetSource()"
  [class.dark]="theme() === 'dark'"
  [class.light]="theme() === 'light'"
>
  <!-- Header -->
  <header class="legal-header">
    <div class="header-inner">
      <div class="logo-mark"></div>
      <span class="header-title">Anihis</span>
    </div>
  </header>

  <!-- Content -->
  <main class="legal-content">
    <div class="legal-container">
      <h1 class="page-title">{{ 'legal.tos.title' | transloco }}</h1>
      <p class="last-updated">{{ 'legal.tos.effectiveDate' | transloco }}</p>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s1.h' | transloco }}</h2>
        @if (!isClientSource()) {
          <p>{{ 'legal.tos.s1.p1_portal' | transloco }}</p>
        } @else {
          <p>{{ 'legal.tos.s1.p1' | transloco }}</p>
        }
        <p>{{ 'legal.tos.s1.p2' | transloco }}</p>
        <p>{{ 'legal.tos.s1.p3' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s2.h' | transloco }}</h2>
        @if (isClientSource() && !isVetSource()) {
          <p>{{ 'legal.tos.s2.intro_client' | transloco }}</p>
        } @else if (isVetSource()) {
          <p>{{ 'legal.tos.s2.intro_vet' | transloco }}</p>
        } @else {
          <p>{{ 'legal.tos.s2.intro' | transloco }}</p>
        }
        <ul>
          <li>
            <strong>{{ 'legal.tos.s2.records_h' | transloco }}</strong>
            {{ 'legal.tos.s2.records_p' | transloco }}
          </li>
          @if (!isClientSource() || isVetSource()) {
            <li>
              <strong>{{ 'legal.tos.s2.practice_h' | transloco }}</strong>
              {{ 'legal.tos.s2.practice_p' | transloco }}
            </li>
          }
          <li>
            <strong>{{ 'legal.tos.s2.appointments_h' | transloco }}</strong>
            {{ 'legal.tos.s2.appointments_p' | transloco }}
          </li>
          @if (isClientSource() && !isVetSource()) {
            <li>
              <strong>{{ 'legal.tos.s2.discovery_h' | transloco }}</strong>
              {{ 'legal.tos.s2.discovery_p_client' | transloco }}
            </li>
            <li>
              <strong>{{ 'legal.tos.s2.location_h' | transloco }}</strong>
              {{ 'legal.tos.s2.location_p' | transloco }}
            </li>
          } @else {
            <li>
              <strong>{{ 'legal.tos.s2.discovery_h' | transloco }}</strong>
              {{ 'legal.tos.s2.discovery_p' | transloco }}
            </li>
          }
          <li>
            <strong>{{ 'legal.tos.s2.profiles_h' | transloco }}</strong>
            {{ 'legal.tos.s2.profiles_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.tos.s2.qr_h' | transloco }}</strong>
            {{ 'legal.tos.s2.qr_p' | transloco }}
          </li>
          <li>
            <strong>{{ 'legal.tos.s2.notifications_h' | transloco }}</strong>
            {{ 'legal.tos.s2.notifications_p' | transloco }}
          </li>
          @if (!isClientSource() || isVetSource()) {
            <li>
              <strong>{{ 'legal.tos.s2.billing_h' | transloco }}</strong>
              {{ 'legal.tos.s2.billing_p' | transloco }}
            </li>
          }
        </ul>
        <p>{{ 'legal.tos.s2.closing' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s3.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s3.intro' | transloco }}</p>
        <ul>
          <li>{{ 'legal.tos.s3.i1' | transloco }}</li>
          <li>{{ 'legal.tos.s3.i2' | transloco }}</li>
          <li>{{ 'legal.tos.s3.i3' | transloco }}</li>
          <li>{{ 'legal.tos.s3.i4' | transloco }}</li>
        </ul>
        <p>{{ 'legal.tos.s3.closing' | transloco }}</p>
      </section>

      @if (!isClientSource() || isVetSource()) {
        <section class="legal-section">
          <h2>{{ 'legal.tos.s4.h' | transloco }}</h2>
          <p>{{ 'legal.tos.s4.intro' | transloco }}</p>
          <ul>
            <li>{{ 'legal.tos.s4.i1' | transloco }}</li>
            <li>{{ 'legal.tos.s4.i2' | transloco }}</li>
            <li>{{ 'legal.tos.s4.i3' | transloco }}</li>
            <li>{{ 'legal.tos.s4.i4' | transloco }}</li>
            <li>{{ 'legal.tos.s4.i5' | transloco }}</li>
          </ul>
          <p>{{ 'legal.tos.s4.closing' | transloco }}</p>
        </section>
      }

      <section class="legal-section">
        <h2>{{ 'legal.tos.s5.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s5.intro' | transloco }}</p>
        <ul>
          <li>{{ 'legal.tos.s5.i1' | transloco }}</li>
          <li>{{ 'legal.tos.s5.i2' | transloco }}</li>
          <li>{{ 'legal.tos.s5.i3' | transloco }}</li>
          <li>{{ 'legal.tos.s5.i4' | transloco }}</li>
          <li>{{ 'legal.tos.s5.i5' | transloco }}</li>
          <li>{{ 'legal.tos.s5.i6' | transloco }}</li>
          <li>{{ 'legal.tos.s5.i7' | transloco }}</li>
          <li>{{ 'legal.tos.s5.i8' | transloco }}</li>
          <li>{{ 'legal.tos.s5.i9' | transloco }}</li>
          <li>{{ 'legal.tos.s5.i10' | transloco }}</li>
        </ul>
        <p>{{ 'legal.tos.s5.closing' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s6.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s6.p1' | transloco }}</p>
        <p>{{ 'legal.tos.s6.p2' | transloco }}</p>
        <p>{{ 'legal.tos.s6.p3' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s7.h' | transloco }}</h2>
        <p>
          <strong>{{ 'legal.tos.s7.important' | transloco }}</strong>
        </p>
        <p>{{ 'legal.tos.s7.p1' | transloco }}</p>
        <ul>
          <li [innerHTML]="'legal.tos.s7.i1' | transloco"></li>
          <li>{{ 'legal.tos.s7.i2' | transloco }}</li>
          <li>{{ 'legal.tos.s7.i3' | transloco }}</li>
          @if (!isClientSource() || isVetSource()) {
            <li>{{ 'legal.tos.s7.i4' | transloco }}</li>
          }
        </ul>
        <p>{{ 'legal.tos.s7.closing' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s8.h' | transloco }}</h2>
        @if (isClientSource() && !isVetSource()) {
          <p>{{ 'legal.tos.s8.mobile_p1' | transloco }}</p>
          <p>{{ 'legal.tos.s8.mobile_p2' | transloco }}</p>
          <p>{{ 'legal.tos.s8.mobile_p3' | transloco }}</p>
        } @else if (isVetSource()) {
          <p>{{ 'legal.tos.s8.vet_p1' | transloco }}</p>
          <p>{{ 'legal.tos.s8.vet_p2' | transloco }}</p>
        } @else {
          <p>{{ 'legal.tos.s8.portal_intro' | transloco }}</p>
          <ul>
            <li [innerHTML]="'legal.tos.s8.portal_monthly' | transloco"></li>
            <li [innerHTML]="'legal.tos.s8.portal_annual' | transloco"></li>
          </ul>
          <p>{{ 'legal.tos.s8.portal_vat' | transloco }}</p>
          <ul>
            <li>
              <strong>{{ 'legal.tos.s8.billing_h' | transloco }}</strong>
              {{ 'legal.tos.s8.billing_p' | transloco }}
            </li>
            <li>
              <strong>{{ 'legal.tos.s8.renew_h' | transloco }}</strong>
              {{ 'legal.tos.s8.renew_p' | transloco }}
            </li>
            <li>
              <strong>{{ 'legal.tos.s8.cancel_h' | transloco }}</strong>
              {{ 'legal.tos.s8.cancel_p' | transloco }}
            </li>
            <li>
              <strong>{{ 'legal.tos.s8.refund_h' | transloco }}</strong>
              {{ 'legal.tos.s8.refund_p' | transloco }}
            </li>
            <li>
              <strong>{{ 'legal.tos.s8.security_h' | transloco }}</strong>
              {{ 'legal.tos.s8.security_p' | transloco }}
            </li>
            <li>
              <strong>{{ 'legal.tos.s8.failed_h' | transloco }}</strong>
              {{ 'legal.tos.s8.failed_p' | transloco }}
            </li>
            <li>
              <strong>{{ 'legal.tos.s8.priceChange_h' | transloco }}</strong>
              {{ 'legal.tos.s8.priceChange_p' | transloco }}
            </li>
            <li>
              <strong>{{ 'legal.tos.s8.nonpayment_h' | transloco }}</strong>
              {{ 'legal.tos.s8.nonpayment_p' | transloco }}
            </li>
          </ul>
        }
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s9.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s9.p1' | transloco }}</p>
        <p>{{ 'legal.tos.s9.p2' | transloco }}</p>
        <p>{{ 'legal.tos.s9.p3' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s10.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s10.intro' | transloco }}</p>
        <ul>
          <li>{{ 'legal.tos.s10.i1' | transloco }}</li>
          <li>{{ 'legal.tos.s10.i2' | transloco }}</li>
          <li>{{ 'legal.tos.s10.i3' | transloco }}</li>
        </ul>
        <p>{{ 'legal.tos.s10.closing' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s11.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s11.p1' | transloco }}</p>
        <p>{{ 'legal.tos.s11.intro' | transloco }}</p>
        <ul>
          <li>{{ 'legal.tos.s11.i1' | transloco }}</li>
          <li>{{ 'legal.tos.s11.i2' | transloco }}</li>
          <li>{{ 'legal.tos.s11.i3' | transloco }}</li>
        </ul>
        <p>{{ 'legal.tos.s11.closing' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s12.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s12.p1' | transloco }}</p>
        <p>{{ 'legal.tos.s12.p2' | transloco }}</p>
        <p>{{ 'legal.tos.s12.p3' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s13.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s13.intro' | transloco }}</p>
        <ul>
          <li>{{ 'legal.tos.s13.i1' | transloco }}</li>
          <li>{{ 'legal.tos.s13.i2' | transloco }}</li>
          <li>{{ 'legal.tos.s13.i3' | transloco }}</li>
          <li>{{ 'legal.tos.s13.i4' | transloco }}</li>
          <li>{{ 'legal.tos.s13.i5' | transloco }}</li>
        </ul>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s14.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s14.p1' | transloco }}</p>
        <p>{{ 'legal.tos.s14.p2' | transloco }}</p>
        <p>{{ 'legal.tos.s14.p3' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s15.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s15.byYou' | transloco }}</p>
        <p>{{ 'legal.tos.s15.byUs_intro' | transloco }}</p>
        <ul>
          <li>{{ 'legal.tos.s15.i1' | transloco }}</li>
          <li>{{ 'legal.tos.s15.i2' | transloco }}</li>
          <li>{{ 'legal.tos.s15.i3' | transloco }}</li>
          <li>{{ 'legal.tos.s15.i4' | transloco }}</li>
        </ul>
        <p>{{ 'legal.tos.s15.closing' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s16.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s16.p1' | transloco }}</p>
        <p>{{ 'legal.tos.s16.amicable' | transloco }}</p>
        <p>
          {{ 'legal.tos.s16.consumer' | transloco }}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            >ec.europa.eu/consumers/odr</a
          >.
        </p>
        <p>{{ 'legal.tos.s16.jurisdiction' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s17.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s17.p1' | transloco }}</p>
        <p>{{ 'legal.tos.s17.p2' | transloco }}</p>
        <p>{{ 'legal.tos.s17.p3' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s18.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s18.p1' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s19.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s19.p1' | transloco }}</p>
        <p>{{ 'legal.tos.s19.p2' | transloco }}</p>
      </section>

      <section class="legal-section">
        <h2>{{ 'legal.tos.s20.h' | transloco }}</h2>
        <p>{{ 'legal.tos.s20.intro' | transloco }}</p>
        <ul>
          <li>
            {{ 'legal.tos.s20.companyLabel' | transloco }}:
            <strong>Anihis doo</strong>
          </li>
          <li>{{ 'legal.tos.s20.regLabel' | transloco }}: 22211382</li>
          <li>{{ 'legal.tos.s20.taxLabel' | transloco }}: 115770230</li>
          <li>
            {{ 'legal.tos.s20.addressLabel' | transloco }}: Omladinska 50, 18360
            Svrljig, Republic of Serbia
          </li>
          <li>
            {{ 'legal.tos.s20.support' | transloco }}:
            <a [href]="'mailto:' + contact.email">{{ contact.email }}</a>
          </li>
          <li>{{ 'legal.tos.s20.inApp' | transloco }}</li>
        </ul>
      </section>
    </div>
  </main>
</div>
